import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneDataReferenceId';
const QS_TYPE: QueryStateSchema['type'] = 'dataReference';

export const useOpenDataReferencePane = (): ((args: { dataReferenceId: string }) => void) => {
  const [dataReferenceIdDeprecated, setDataReferenceId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (dataReferenceIdDeprecated) {
      setDataReferenceId(null);
      setState(backwardsCompatabilityFactory({ id: dataReferenceIdDeprecated, type: QS_TYPE }));
    }
  }, [dataReferenceIdDeprecated]);

  return ({ dataReferenceId }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: dataReferenceId,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
